import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../api';
import Swal from 'sweetalert2';

const ICONS = {
    search: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>,
    filter: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>,
    calendar: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
    clock: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>,
    actor: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
};

const AuditLogs = () => {
    const [logs, setLogs] = useState([]);
    const [filters, setFilters] = useState({ type: '', startDate: '', endDate: '' });

    const fetchLogs = async () => {
        try {
            const token = localStorage.getItem('token');
            const query = new URLSearchParams(filters).toString();
            const { data } = await axios.get(`${API_BASE_URL}/api/audit-logs?${query}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setLogs(data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => { fetchLogs(); }, [filters]);

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const showLogDetails = (log) => {
        Swal.fire({
            title: '<span style="font-family: \'Outfit\', sans-serif; font-weight: 700; color: #2C1A10; font-size: 20px;">Dossier Fragment Details</span>',
            html: `
                <div style="text-align: left; background: #2C1A10; padding: 25px; borderRadius: 16px; color: #EAD7BB; font-family: 'Roboto Mono', monospace; font-size: 13px; max-height: 400px; overflow-y: auto; border: 1px solid #C0722C;">
                    <pre style="margin: 0; white-space: pre-wrap; word-break: break-all;">${JSON.stringify(log.details, null, 4)}</pre>
                </div>
                <div style="margin-top: 20px; text-align: left; font-family: 'Outfit', sans-serif;">
                    <p style="margin: 5px 0; color: #666; font-size: 14px;"><strong>Chronology:</strong> ${new Date(log.timestamp).toLocaleString()}</p>
                    <p style="margin: 5px 0; color: #666; font-size: 14px;"><strong>Vector:</strong> ${log.actionType}</p>
                    <p style="margin: 5px 0; color: #666; font-size: 14px;"><strong>Origin IP:</strong> ${log.ipAddress}</p>
                </div>
            `,
            width: '700px',
            confirmButtonText: 'Acknowledged',
            confirmButtonColor: '#2C1A10',
            background: '#FFFFFF',
            borderRadius: '24px'
        });
    };

    return (
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <div style={{ marginBottom: '40px' }}>
                <h1 style={{ margin: '0 0 8px 0', fontSize: '32px', fontWeight: '800', color: '#2C1A10' }}>Forensic Dossier</h1>
                <p style={{ margin: 0, color: '#999', fontSize: '16px' }}>Immutable blockchain-style record of all executive directives.</p>
            </div>

            {/* Masterpiece Filter Array */}
            <div style={{
                display: 'flex',
                gap: '20px',
                marginBottom: '35px',
                backgroundColor: 'white',
                padding: '25px',
                borderRadius: '24px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.02)',
                border: '1px solid #F0E8DB',
                alignItems: 'center',
                flexWrap: 'wrap'
            }}>
                <div style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
                    <span style={{ position: 'absolute', left: '15px', top: '50%', transform: 'translateY(-50%)', color: '#C0722C', display: 'flex' }}>
                        {ICONS.filter}
                    </span>
                    <select
                        name="type"
                        onChange={handleFilterChange}
                        style={{
                            width: '100%',
                            padding: '12px 15px 12px 45px',
                            borderRadius: '12px',
                            border: '1.5px solid #F0E8DB',
                            backgroundColor: '#FDF8F3',
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#2C1A10',
                            outline: 'none',
                            cursor: 'pointer',
                            appearance: 'none',
                            fontFamily: '"Outfit", sans-serif'
                        }}
                    >
                        <option value="">All Directives</option>
                        <option value="LOGIN_SUCCESS">Identity Auth Success</option>
                        <option value="LOGIN_FAILED">Breach Attempted</option>
                        <option value="USER_CREATED">Personnel Onboarded</option>
                        <option value="DESIGNATION_CHANGED">Authority Modified</option>
                        <option value="SECURITY_CONFIG_UPDATED">Encryption Policy Shift</option>
                    </select>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1, minWidth: '350px', flexWrap: 'wrap' }}>
                    <div style={{ position: 'relative', flex: '1 1 140px' }}>
                        <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#999', display: 'flex' }}>{ICONS.calendar}</span>
                        <input
                            type="date"
                            name="startDate"
                            onChange={handleFilterChange}
                            style={{ width: '100%', boxSizing: 'border-box', padding: '12px 12px 12px 40px', borderRadius: '12px', border: '1.5px solid #F0E8DB', backgroundColor: '#FDF8F3', fontSize: '13px', fontWeight: '500', outline: 'none', color: '#2C1A10', fontFamily: '"Outfit", sans-serif' }}
                        />
                    </div>
                    <span style={{ color: '#DDD', fontWeight: 'bold' }}>→</span>
                    <div style={{ position: 'relative', flex: '1 1 140px' }}>
                        <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#999', display: 'flex' }}>{ICONS.calendar}</span>
                        <input
                            type="date"
                            name="endDate"
                            onChange={handleFilterChange}
                            style={{ width: '100%', boxSizing: 'border-box', padding: '12px 12px 12px 40px', borderRadius: '12px', border: '1.5px solid #F0E8DB', backgroundColor: '#FDF8F3', fontSize: '13px', fontWeight: '500', outline: 'none', color: '#2C1A10', fontFamily: '"Outfit", sans-serif' }}
                        />
                    </div>
                </div>
            </div>

            {/* Logs Table - Spaced Aesthetic */}
            <div style={{ backgroundColor: 'white', borderRadius: '24px', boxShadow: '0 15px 45px rgba(0,0,0,0.04)', overflow: 'hidden', border: '1px solid #F0E8DB' }}>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', fontSize: '14px' }}>
                    <thead style={{ backgroundColor: '#2C1A10', color: '#EAD7BB' }}>
                        <tr>
                            <th style={{ padding: '20px 25px', textAlign: 'left', fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>Chronology</th>
                            <th style={{ padding: '20px 25px', textAlign: 'left', fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>Directing Actor</th>
                            <th style={{ padding: '20px 25px', textAlign: 'left', fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>Action Vector</th>
                            <th style={{ padding: '20px 25px', textAlign: 'left', fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>Parameters</th>
                            <th style={{ padding: '20px 25px', textAlign: 'left', fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>IP Origin</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs.length === 0 ? (
                            <tr><td colSpan="5" style={{ padding: '60px', textAlign: 'center', color: '#AAA', fontWeight: '500' }}>No records found in current dossier.</td></tr>
                        ) : (
                            logs.map(log => (
                                <tr key={log._id} style={{ borderBottom: '1px solid #F5F0E8' }}>
                                    <td style={{ padding: '20px 25px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#2C1A10', fontWeight: '700' }}>
                                            {ICONS.clock}
                                            {new Date(log.timestamp).toLocaleTimeString()}
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#999', marginTop: '4px', marginLeft: '22px' }}>
                                            {new Date(log.timestamp).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' })}
                                        </div>
                                    </td>
                                    <td style={{ padding: '20px 25px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '700', color: '#333' }}>
                                            <span style={{ color: '#C0722C' }}>{ICONS.actor}</span>
                                            {typeof log.actorId === 'object'
                                                ? `${log.actorId?.firstName || 'SYSTEM'} ${log.actorId?.lastName || ''}`
                                                : log.actorId}
                                        </div>
                                    </td>
                                    <td style={{ padding: '20px 25px' }}>
                                        <span style={{
                                            padding: '6px 12px',
                                            borderRadius: '8px',
                                            backgroundColor: log.actionType.includes('FAILED') ? '#FFF5F5' : '#F0F7FF',
                                            color: log.actionType.includes('FAILED') ? '#E53935' : '#0070E0',
                                            fontWeight: '800',
                                            fontSize: '11px',
                                            border: `1px solid ${log.actionType.includes('FAILED') ? '#FFEBEE' : '#E1F0FF'}`,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>
                                            {log.actionType.replace(/_/g, ' ')}
                                        </span>
                                    </td>
                                    <td style={{ padding: '20px 25px' }}>
                                        <div
                                            onClick={() => showLogDetails(log)}
                                            style={{
                                                maxWidth: '220px',
                                                fontSize: '11px',
                                                color: '#666',
                                                backgroundColor: '#F9F9F9',
                                                padding: '8px 12px',
                                                borderRadius: '8px',
                                                border: '1px solid #EEE',
                                                fontFamily: '"Roboto Mono", monospace',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                transition: 'all 0.2s'
                                            }}
                                            onMouseOver={(e) => { e.currentTarget.style.borderColor = '#C0722C'; e.currentTarget.style.backgroundColor = '#FFF'; }}
                                            onMouseOut={(e) => { e.currentTarget.style.borderColor = '#EEE'; e.currentTarget.style.backgroundColor = '#F9F9F9'; }}
                                        >
                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{JSON.stringify(log.details)}</span>
                                            <span style={{ fontSize: '10px', color: '#C0722C', fontWeight: '800', marginLeft: '5px' }}>VIEW</span>
                                        </div>
                                    </td>
                                    <td style={{ padding: '20px 25px', fontFamily: '"Roboto Mono", monospace', color: '#888', fontWeight: '600', fontSize: '13px' }}>
                                        {log.ipAddress}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AuditLogs;
